<template>
  <div>
    <div class="mt-2 ml-2">
      <div class="text-h7 font-weight-bold">
        イントラネット → インターネット
      </div>
      <v-table class="border-less" density="compact">
        <thead class="v-table-head text-caption">
          <tr>
            <th>送信元アドレス</th>
            <th>宛先アドレス</th>
            <th>サービス</th>
            <th>アクション</th>
            <th>インターネットFW</th>
            <template v-if="applianceType === 'UTM'">
              <th>IDS/IPS</th>
              <th>
                <div>Web</div>
                アンチウイルス
              </th>
              <th>
                <div>URL</div>
                フィルタリング
              </th>
              <th>
                <div>メール</div>
                アンチウイルス
              </th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>any</td>
            <td>any</td>
            <td>any</td>
            <td>Allow</td>
            <td>any</td>
            <template v-if="applianceType === 'UTM'">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </template>
          </tr>
          <tr class="tr_lightGray">
            <td>any</td>
            <td>any</td>
            <td>any</td>
            <td>Deny</td>
            <td></td>
            <template v-if="applianceType === 'UTM'">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </template>
          </tr>
        </tbody>
      </v-table>
    </div>
    <div class="mt-2 ml-2">
      <div class="text-h7 font-weight-bold">
        インターネット → イントラネット
      </div>
      <v-table class="border-less" density="compact">
        <thead class="v-table-head text-caption">
          <tr>
            <th>送信元アドレス</th>
            <th>宛先アドレス</th>
            <th>サービス</th>
            <th>アクション</th>
            <th>インターネットFW</th>
            <template v-if="applianceType === 'UTM'">
              <th>IDS/IPS</th>
              <th>
                <div>Web</div>
                アンチウイルス
              </th>
              <th>
                <div>URL</div>
                フィルタリング
              </th>
              <th>
                <div>メール</div>
                アンチウイルス
              </th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>any</td>
            <td>any</td>
            <td>any</td>
            <td>Allow</td>
            <td>any</td>
            <template v-if="applianceType === 'UTM'">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </template>
          </tr>
          <tr class="tr_lightGray">
            <td>any</td>
            <td>any</td>
            <td>any</td>
            <td>Deny</td>
            <td></td>
            <template v-if="applianceType === 'UTM'">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </template>
          </tr>
        </tbody>
      </v-table>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";

export default defineComponent({
  name: "DefaultPolicyInteractiveAny",
  props: {
    applianceType: {
      type: String as PropType<string>,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.tr_lightGray {
  background-color: #f5f5f5;
}
// WVS2UI-13586 #170 編集可能デフォルトポリシー展開後の表のヘッダーが左寄せになっている
.v-table__wrapper > table > thead > tr > th {
  text-align: center;
}
</style>
